<template>
  <div class="sidebar">
    <nav class="sidebar1-nav ">
      <section
        data-v-2ba57165=""
        data-ps-id="3ae5f37d-fe43-8dce-695a-4d28e9ab1f3b"
        class="ps-container scroll-area ps ps--theme_default"
      >
        <!---- If Super Admin -->
        <ul v-if="this.user_type == 'Admin'" data-v-2ba57165="" class="nav">
          <li class="nav-item">
            <router-link
              to="/dashboard_admin_brand"
              class="nav-link"
              title="Dashboard"
            >
              <i class="fa fa-dashboard icons" style="font-size:25px;"></i>
            </router-link>
          </li>
          <!-- 
            <li class="nav-item">

            	
					<router-link to="/dashboard_brandwise" class="nav-link" title="Brandwise Records">
						
						<i class="fa fa-shopping-bag icons" style="font-size:25px;" ></i>
								
					</router-link>

	            </li> -->

          <!-- <li class="nav-item">
            <router-link to="/style_list/all" class="nav-link" title="Styles">
              <i class="fa fa-modx icons" style="font-size:25px;"></i>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/samplelisting" class="nav-link" title="Sample">
              <i class="fa fa-life-ring" style="font-size:25px;"></i>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              to="/searchrecords"
              class="nav-link"
              title="Vendor Records"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="sidebar-custom__img"
                alt="Vendor Records"
              >
                <path
                  d="M8.05 1H15.75V4.575L19.6364 5.63492C20.7892 5.94932 21.4109 7.19779 20.9671 8.30723L17.835 16.1374C17.5553 16.8368 17.5489 17.6157 17.817 18.3196L19.6 23H4.2L5.98301 18.3196C6.25115 17.6157 6.24471 16.8368 5.96498 16.1374L2.83289 8.30723C2.38912 7.1978 3.01081 5.94932 4.16361 5.63492L8.05 4.575V1Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                ></path>
                <line
                  x1="6.16846"
                  y1="16.9236"
                  x2="18.1527"
                  y2="16.9236"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                ></line>
                <line
                  x1="11.825"
                  y1="1"
                  x2="11.825"
                  y2="16.4"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                ></line>
              </svg>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/quotition" class="nav-link" title="Quotation">
              <i class="fa fa-tags" style="font-size:25px;"></i>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              to="/productionlist"
              class="nav-link"
              title="Production"
            >
              <i class="fa fa-sitemap icons" style="font-size:25px;"></i>
            </router-link>
          </li> -->
          <!-- <li class="nav-item">

            	
					<router-link to="/orderslisting" class="nav-link" title="Orders">
						
						<i class="fa fa-shopping-bag icons" style="font-size:25px;" ></i>
								
					</router-link>

	            </li> -->

          <li class="nav-item">
            <router-link to="/usersdetails" class="nav-link" title="Settings">
              <i
                class="fa fa-cogs"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/ordersheet" class="nav-link" title="Report">
              <i
                class="fa fa-file-text-o"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li>
        </ul>
        <!---- If Super Admin Ends --->

        <!---- If Quality Controller -->
        <ul
          v-if="this.user_type == 'Quality_Controller'"
          data-v-2ba57165=""
          class="nav"
        >
          <li class="nav-item">
            <router-link
              to="/dashboard_quality"
              class="nav-link"
              title="Dashboard"
            >
              <i class="fa fa-dashboard icons" style="font-size:25px;"></i>
            </router-link>
          </li>

          <!--   <li class="nav-item">

            	
					<router-link to="/design_details/1233" class="nav-link" title="Styles">
						
						<i class="fa fa-industry" style="font-size:25px; color: 4682B4" aria-hidden="true"></i>
					</router-link>

	            </li> -->

          <li class="nav-item">
            <router-link to="/usersdetails" class="nav-link" title="Settings">
              <i
                class="fa fa-cogs"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              to="/allocate_inspection/"
              class="nav-link"
              title="Allocate inspection to QC"
            >
              <i
                class="fa fa-tasks"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li>
        </ul>
        <!---- If Quality Controller Ends --->

        <!---- If Quality Controller -->
        <ul
          v-if="this.user_type == 'Quality_Executive'"
          data-v-2ba57165=""
          class="nav"
        >
          <li class="nav-item">
            <router-link
              to="/dashboard_quality_executive"
              class="nav-link"
              title="Dashboard"
            >
              <i class="fa fa-dashboard icons" style="font-size:25px;"></i>
            </router-link>
          </li>

          <!-- <li class="nav-item">

            	
					<router-link to="/qc_executive_tna/1245" class="nav-link" title="Production">
						
						<i class="fa fa-sitemap icons" style="font-size:25px;" ></i>
								
					</router-link>

	            </li> -->

          <!-- <li class="nav-item">
					<router-link to="/usersdetails" class="nav-link" title="Settings">
						
						<i class="fa fa-cogs" aria-hidden="true" style="font-size:25px;"></i>					
					</router-link>

	            </li> -->
        </ul>
        <!---- If Quality Controller Ends --->

        <!---- If Quality Head -->
        <ul
          v-if="this.user_type == 'Quality_Head'"
          data-v-2ba57165=""
          class="nav"
        >
          <li class="nav-item">
            <router-link
              to="/dashboard_quality"
              class="nav-link"
              title="Dashboard"
            >
              <i class="fa fa-dashboard icons" style="font-size:25px;"></i>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/styles" class="nav-link" title="Styles">
              <i class="fa fa-modx icons" style="font-size:25px;"></i>
            </router-link>
          </li>

          <!-- <li class="nav-item">
					<router-link to="/usersdetails" class="nav-link" title="Settings">
						
						<i class="fa fa-cogs" aria-hidden="true" style="font-size:25px;"></i>					
					</router-link>

	            </li> -->
        </ul>
        <!---- If Quality Head Ends --->

        <ul v-if="this.user_type == 9" data-v-2ba57165="" class="nav">
          <li>
            <a><i class="fa fa-modx icons" style="font-size:25px;"></i></a>
          </li>
        </ul>

        <!---- If Brand Manager --->
        <ul
          v-if="this.user_type == 'Brand_Manager'"
          data-v-2ba57165=""
          class="nav"
        >
          <!-- class="router-link-exact-active open active nav-link" -->
          <li class="nav-item">
            <router-link
              to="/dashboard_brand_manager"
              class="nav-link"
              title="Dashboard"
            >
              <i class="fa fa-dashboard icons" style="font-size:25px;"></i>
            </router-link>
          </li>
          <li>
            <router-link to="/brands" class="nav-link" title="Collections">
              <svg
                width="26"
                height="24"
                viewBox="0 0 26 24"
                fill="none"
                class="sidebar-custom__img"
                alt="Collections"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1 8C1 4.13401 4.13401 1 8 1H18C21.866 1 25 4.13401 25 8V14H20V19H6V14H1V8Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M8 1C8 3.76142 10.2386 6 13 6C15.7614 6 18 3.76142 18 1"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M6 18.5V9.5"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M20 18.5V9.5"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M3 19H23"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M5 23H21"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </router-link>
          </li>

          <!-- <li class="nav-item">
            <router-link
              to="/searchrecords"
              class="nav-link"
              title="Vendor Records"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="sidebar-custom__img"
                alt="Vendor Records"
              >
                <path
                  d="M8.05 1H15.75V4.575L19.6364 5.63492C20.7892 5.94932 21.4109 7.19779 20.9671 8.30723L17.835 16.1374C17.5553 16.8368 17.5489 17.6157 17.817 18.3196L19.6 23H4.2L5.98301 18.3196C6.25115 17.6157 6.24471 16.8368 5.96498 16.1374L2.83289 8.30723C2.38912 7.1978 3.01081 5.94932 4.16361 5.63492L8.05 4.575V1Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                ></path>
                <line
                  x1="6.16846"
                  y1="16.9236"
                  x2="18.1527"
                  y2="16.9236"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                ></line>
                <line
                  x1="11.825"
                  y1="1"
                  x2="11.825"
                  y2="16.4"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                ></line>
              </svg>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/allrecords" class="nav-link" title="Quotes">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="sidebar-custom__img"
                alt="Quotes"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M14 2V8H20"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M16 13H8"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M16 17H8"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M10 9H9H8"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <circle cx="17" cy="17" r="7" fill="white"></circle>
                <path
                  d="M17.6479 18.9337C17.3694 19.2121 16.4971 19.2113 16.2193 18.9337C15.9404 18.6547 15.4881 18.6547 15.2092 18.9337C14.9302 19.2126 14.9303 19.6649 15.2092 19.9438C15.5088 20.2434 15.9381 20.447 16.4285 20.5298V21.2857C16.4285 21.6802 16.7483 22 17.1428 22C17.5373 22 17.8571 21.6802 17.8571 21.2857V20.4243C19.7318 19.7871 19.6781 17.277 17.9646 16.5673L16.8678 16.1129C16.297 15.8766 16.1944 14.8572 17.3521 14.8572C17.701 14.8572 17.9622 14.9623 18.0664 15.0664C18.3453 15.3454 18.7976 15.3454 19.0765 15.0664C19.3555 14.7875 19.3554 14.3352 19.0765 14.0563C18.7769 13.7567 18.3477 13.5531 17.8572 13.4703V12.7143C17.8572 12.3198 17.5374 12 17.1429 12C16.7484 12 16.4286 12.3198 16.4286 12.7143V13.5757C14.5702 14.2074 14.593 16.7169 16.3211 17.4327L17.4179 17.8871C17.8293 18.0575 17.9799 18.6007 17.6479 18.9337Z"
                  fill="#0067E2"
                ></path>
              </svg>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              to="/color_finder"
              class="nav-link"
              title="Color Finder"
            >
              <i class="fa fa-pencil icons" style="font-size:25px;"></i>
            </router-link>
          </li> -->

          <!-- <li class="nav-item">
            <router-link to="/usersdetails" class="nav-link" title="Settings">
              <i
                class="fa fa-cogs"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li> -->

          <li class="nav-item">
            <router-link to="/ordersheet" class="nav-link" title="Report">
              <i
                class="fa fa-file-text-o"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li>
        </ul>
        <!---- If Brand Manager  --->

        <!---- If Designer --->
        <ul
          v-if="this.user_type == 'Brand_Designer'"
          data-v-2ba57165=""
          class="nav"
        >
          <li class="nav-item">
            <router-link
              to="/dashboard_designer"
              class="nav-link"
              title="Dashboard"
            >
              <i class="fa fa-dashboard icons" style="font-size:25px;"></i>
            </router-link>
          </li>
          <li class="nav-item" >
            <!-- class="router-link-exact-active open active nav-link" -->

            <router-link to="/brands" class="nav-link" title="Collections">
              <svg
                width="26"
                height="24"
                viewBox="0 0 26 24"
                fill="none"
                class="sidebar-custom__img"
                alt="Collections"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1 8C1 4.13401 4.13401 1 8 1H18C21.866 1 25 4.13401 25 8V14H20V19H6V14H1V8Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M8 1C8 3.76142 10.2386 6 13 6C15.7614 6 18 3.76142 18 1"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M6 18.5V9.5"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M20 18.5V9.5"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M3 19H23"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M5 23H21"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </router-link>
          </li>
          <!-- <li class="nav-item">
            <router-link
              to="/searchrecords"
              class="nav-link"
              title="Vendor Records"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="sidebar-custom__img"
                alt="Vendor Records"
              >
                <path
                  d="M8.05 1H15.75V4.575L19.6364 5.63492C20.7892 5.94932 21.4109 7.19779 20.9671 8.30723L17.835 16.1374C17.5553 16.8368 17.5489 17.6157 17.817 18.3196L19.6 23H4.2L5.98301 18.3196C6.25115 17.6157 6.24471 16.8368 5.96498 16.1374L2.83289 8.30723C2.38912 7.1978 3.01081 5.94932 4.16361 5.63492L8.05 4.575V1Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                ></path>
                <line
                  x1="6.16846"
                  y1="16.9236"
                  x2="18.1527"
                  y2="16.9236"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                ></line>
                <line
                  x1="11.825"
                  y1="1"
                  x2="11.825"
                  y2="16.4"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                ></line>
              </svg>
            </router-link>
          </li> -->

          <li>
            <router-link
              to="/graphics_designer"
              class="nav-link"
              title="Gallery"
            >
              <i
                class="fa fa-picture-o"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li>
          <li>
            <router-link
              to="/create_artwork"
              class="nav-link"
              title="Techpack"
            >
              <i
                class="fa fa-edit"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li>

          <!-- <li class="nav-item">
					<router-link to="/usersdetails" class="nav-link" title="Settings">
						
						<i class="fa fa-cogs" aria-hidden="true" style="font-size:25px;"></i>					
					</router-link>

	            </li> -->
        </ul>
        <!---- If Designer  --->

        <!---- If Designer --->
        <ul
          v-if="this.user_type == 'Graphics_Designer'"
          data-v-2ba57165=""
          class="nav"
        >
          <li>
            <router-link
              to="/graphics_designer"
              class="nav-link"
              title="Gallery"
            >
              <i
                class="fa fa-picture-o"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li>

          <li>
            <router-link
              to="/create_artwork"
              class="nav-link"
              title="Techpack"
            >
              <i
                class="fa fa-edit"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li>

          <!-- <li class="nav-item">
					<router-link to="/usersdetails" class="nav-link" title="Settings">
						
						<i class="fa fa-cogs" aria-hidden="true" style="font-size:25px;"></i>					
					</router-link>

	            </li> -->
        </ul>

        <ul
          v-if="this.user_type == 'ME_USER'"
          data-v-2ba57165=""
          class="nav"
        >
          <li class="nav-item">
            <router-link
              to="/me_dashboard"
              class="nav-link"
              title="Dashboard"
            >
              <i class="fa fa-dashboard icons" style="font-size:25px;"></i>
            </router-link>
          </li>

        
        </ul>
        <!---- If Designer  --->

        <!---- If Fit Technician --->
        <ul
          v-if="this.user_type == 'Fit_Technician'"
          data-v-2ba57165=""
          class="nav"
        >
          <li class="nav-item">
            <router-link
              to="/dashboard_fit_tech"
              class="nav-link"
              title="Dashboard"
            >
              <i class="fa fa-dashboard icons" style="font-size:25px;"></i>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link
              to="/fittech_list"
              class="nav-link"
              title="FitTech List"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="sidebar-custom__img"
                alt="Quotes"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M14 2V8H20"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M16 13H8"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M16 17H8"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M10 9H9H8"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <circle cx="17" cy="17" r="7" fill="white"></circle>
                <path
                  d="M17.6479 18.9337C17.3694 19.2121 16.4971 19.2113 16.2193 18.9337C15.9404 18.6547 15.4881 18.6547 15.2092 18.9337C14.9302 19.2126 14.9303 19.6649 15.2092 19.9438C15.5088 20.2434 15.9381 20.447 16.4285 20.5298V21.2857C16.4285 21.6802 16.7483 22 17.1428 22C17.5373 22 17.8571 21.6802 17.8571 21.2857V20.4243C19.7318 19.7871 19.6781 17.277 17.9646 16.5673L16.8678 16.1129C16.297 15.8766 16.1944 14.8572 17.3521 14.8572C17.701 14.8572 17.9622 14.9623 18.0664 15.0664C18.3453 15.3454 18.7976 15.3454 19.0765 15.0664C19.3555 14.7875 19.3554 14.3352 19.0765 14.0563C18.7769 13.7567 18.3477 13.5531 17.8572 13.4703V12.7143C17.8572 12.3198 17.5374 12 17.1429 12C16.7484 12 16.4286 12.3198 16.4286 12.7143V13.5757C14.5702 14.2074 14.593 16.7169 16.3211 17.4327L17.4179 17.8871C17.8293 18.0575 17.9799 18.6007 17.6479 18.9337Z"
                  fill="#0067E2"
                ></path>
              </svg>
            </router-link>
          </li>
          <!-- <li class="nav-item">
				<router-link to="/usersdetails" class="nav-link" title="Settings">
					
					<i class="fa fa-cogs" aria-hidden="true" style="font-size:25px;"></i>					
				</router-link>

			</li> -->

          <!-- <li class="nav-item">
            <router-link to="/fittech_log" class="nav-link" title="FitTech Log">
              <i
                class="fa fa-file"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li> -->
        </ul>
        <!---- If Fit Technician  --->

        <!---- If Other User --->
        <ul
          v-if="
            this.user_type != 'Brand_Manager' &&
              this.user_type != 'Admin' &&
              this.user_type != 'Design_Head' &&
              this.user_type != 'Fit_Technician' &&
              this.user_type != 'Brand_Designer' &&
              this.user_type != 'Quality_Head' &&
              this.user_type != 'Quality_Controller' &&
              this.user_type != 'Quality_Executive' &&
              this.user_type != 'Graphics_Designer' &&
              this.user_type != 'ME_USER'
     
          "
          data-v-2ba57165=""
          class="nav"
        >
          <!-- class="router-link-exact-active open active nav-link" -->
          <li class="nav-item" v-if="this.user_type != 'PO Executive' && this.user_type != 'Planner_Admin' && this.user_type != 'Planner' && this.user_type != 'Buying_Head'">
            <router-link
              to="/dashboard_buyer"
              class="nav-link"
              title="Dashboard"
            >
              <i class="fa fa-dashboard icons" style="font-size:25px;"></i>
            </router-link>
          </li>

          <li class="nav-item" v-if="this.user_type == 'PO Executive'">
            <router-link
              to="/dashboard_brand_manager"
              class="nav-link"
              title="Dashboardcc"
            >
              <i class="fa fa-dashboard icons" style="font-size:25px;"></i>
            </router-link>
          </li>
          <li v-if="this.user_type != 'PO Executive' &&  this.user_type != 'Junior_Buyer' && this.user_type != 'Planner_Admin'  && this.user_type != 'Planner' && this.user_type != 'Buying_Head'">
            <router-link to="/brands" class="nav-link" title="Collections">
              <svg
                width="26"
                height="24"
                viewBox="0 0 26 24"
                fill="none"
                class="sidebar-custom__img"
                alt="Collections"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1 8C1 4.13401 4.13401 1 8 1H18C21.866 1 25 4.13401 25 8V14H20V19H6V14H1V8Z"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M8 1C8 3.76142 10.2386 6 13 6C15.7614 6 18 3.76142 18 1"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M6 18.5V9.5"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M20 18.5V9.5"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M3 19H23"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M5 23H21"
                  stroke="white"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </router-link>
          </li>

          <!-- <li class="nav-item">
					<router-link to="/usersdetails" class="nav-link" title="Settings">
						
						<i class="fa fa-cogs" aria-hidden="true" style="font-size:25px;"></i>				
					</router-link>
				</li> -->

          <li class="nav-item" v-if="this.user_type != 'PO Executive' && this.user_type != 'Planner_Admin' && this.user_type != 'Planner' && this.user_type != 'Buying_Head'">
            <router-link to="/ordersheet" class="nav-link" title="Report">
              <i
                class="fa fa-file-text-o"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li>
        </ul>
        <!---- If Other User  --->

        <ul
          v-if="this.user_type == 'Buyer' || this.user_type == 'Brand_Manager' || this.user_type == 'Junior_Buyer'"
          data-v-2ba57165=""
          class="nav"
        >
         <li class="nav-item" v-if="this.user_type != 'Junior_Buyer'">
            <router-link to="/usersdetails" class="nav-link" title="Settings">
                
                <i class="fa fa-cogs" aria-hidden="true" style="font-size:25px;"></i>				
            </router-link>
         </li>
        
          <li class="nav-item">
            <router-link
              to="/allocate_inspection/"
              class="nav-link"
              title="Allocate inspection to QC"
            >
              <i
                class="fa fa-tasks"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li>
           
        </ul>


         <ul
          v-if="this.user_type == 'Brand_Manager' "
          data-v-2ba57165=""
          class="nav"
          >
           
            <li class="nav-item">
            <router-link to="/uploadBomFile" class="nav-link" title="Upload BOM">
              <i
                class="fa fa-upload"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li>
           
        </ul>

        <!---- If Design Head --->
        <ul
          v-if="this.user_type == 'Design_Head'"
          data-v-2ba57165=""
          class="nav"
        >
          <li class="nav-item">
            <router-link
              to="/dashboard_designhead"
              class="nav-link"
              title="Dashboard"
            >
              <i class="fa fa-dashboard icons" style="font-size:25px;"></i>
            </router-link>
          </li>

          <!-- <li class="nav-item">
            <router-link to="/style_list/all" class="nav-link" title="Styles">
              <i class="fa fa-modx icons" style="font-size:25px;"></i>
            </router-link>
          </li> -->

          <!-- <li class="nav-item">
					<router-link to="/usersdetails" class="nav-link" title="Settings">
						
						<i class="fa fa-cogs" aria-hidden="true" style="font-size:25px;"></i>
				
					</router-link>
				</li> -->
          <li class="nav-item">
            <router-link to="/ordersheet" class="nav-link" title="Report">
              <i
                class="fa fa-file-text-o"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li>
          <li>
            <router-link
              to="/create_artwork"
              class="nav-link"
              title="Techpack"
            >
              <i
                class="fa fa-edit"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li>

        </ul>
        <!---- If Design Head  --->

        <!---- If PO Executive -->
        <ul
          v-if="this.user_type == 'PO Executive'"
          data-v-2ba57165=""
          class="nav"
        >
          <!-- <li class="nav-item">

            	
				<router-link to="/dashboard_quality" class="nav-link" title="Dashboard">
					
					<i class="fa fa-dashboard icons" style="font-size:25px;" ></i>
							
				</router-link>

            </li> -->
          <!-- 
          <li class="nav-item">
            <router-link to="/styles" class="nav-link" title="Styles">
              <i class="fa fa-modx icons" style="font-size:25px;"></i>
            </router-link>
          </li> -->

          <!-- 
	               <li class="nav-item">
					<router-link to="/updateProfile" class="nav-link" title="Settings">
						
						<i class="fa fa-cogs" aria-hidden="true" style="font-size:25px;"></i>					
					</router-link>

	            </li> -->
        </ul>
        <!---- If PO Executive Ends --->
        <ul
            v-if="this.user_type == 'Buying_Head'"
            data-v-2ba57165=""
            class="nav"
            >

             <li class="nav-item" >
                <router-link
                to="/dashboard_buyingHead"
                class="nav-link"
                title="Dashboard"
              >
                <i class="fa fa-dashboard icons" style="font-size:25px;"></i>
              </router-link>
            </li>

            <li class="nav-item">
            <router-link
              to="/allocate_inspection/"
              class="nav-link"
              title="Allocate inspection to QC"
            >
              <i
                class="fa fa-tasks"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li>

            
         </ul>
      

        <!-- Planner Admin Starts -->
            <ul
            v-if="this.user_type == 'Planner_Admin' || this.user_type == 'Planner'"
            data-v-2ba57165=""
            class="nav"
            >

                       <li class="nav-item">
            <router-link
              to="/dashboard_quality"
              class="nav-link"
              title="Dashboard"
            >
              <i class="fa fa-dashboard icons" style="font-size:25px;"></i>
            </router-link>
          </li>

             <li class="nav-item" >
                <router-link to="/mccreport" class="nav-link" title="Report">
                <i
                    class="fa fa-file-text-o"
                    aria-hidden="true"
                    style="font-size:25px;"
                ></i>
                </router-link>
            </li>
            
	         <li class="nav-item" v-if="this.user_type != 'Planner'">
                <router-link to="/usersdetails" class="nav-link" title="Settings" >
                    
                    <i class="fa fa-cogs" aria-hidden="true" style="font-size:25px;"></i>				
                </router-link>
            </li> 

            <li class="nav-item">
                <router-link to="/upload_plan" class="nav-link" title="Upload Plan">
                    
                    <i class="fa fa-upload" aria-hidden="true" style="font-size:25px;"></i>				
                </router-link>
            </li>
            <!-- grade_minmax -->
            <li class="nav-item">
                <router-link to="/grade_minmax" class="nav-link" title="Grade Min Max values">
                    
                    <i class="fa fa-pencil" aria-hidden="true" style="font-size:25px;"></i>				
                </router-link>
            </li>

  

  
<!-- 
          <li class="nav-item">
            <router-link to="/usersdetails" class="nav-link" title="Settings">
              <i
                class="fa fa-cogs"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li> -->

          <li class="nav-item">
            <router-link
              to="/allocate_inspection/"
              class="nav-link"
              title="Allocate inspection to QC"
            >
              <i
                class="fa fa-tasks"
                aria-hidden="true"
                style="font-size:25px;"
              ></i>
            </router-link>
          </li>

         </ul>
        <!-- Planner Admin Ends -->
         
      </section>
    </nav>
  </div>
</template>

<style>
.sidebar-fixed .sidebar {
  position: fixed;
  z-index: 1019;
  width: 80px !important;
  height: 100vh;
}

.sidebar .nav {
  width: 80px !important;
}

.sidebar .nav-link {
  display: block;
  padding: 0.75rem 1.5rem !important;
  color: #fff;
  text-decoration: none;
  background: transparent;
}
</style>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from "vue";
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown,
  },
  data: () => {
    return {
      itemsCount: 42,
      email: "",
      adminuser: "",
      user_type: "",
      get codUser() {
        return localStorage.getItem("Coduser") || "";
      },
      isSidebarFixed: true,
    };
  },
  mounted() {  
      document.body.classList.add('sidebar-fixed');
  },
  created() {
    var userData = localStorage.getItem("userData");
    if (userData) {
      var userInfo = JSON.parse(userData);
      this.user_type = userInfo[0].user_type;
    }
  },
  methods: {},
};
</script>
